import {Service} from '@/request/http.js'

// 获取 我的行程
export function getTripList (data) {
  return Service({
    url: '/api/getTripList',
    method: 'post',
    params: data
  })
}

// 获取 行程详情
export function getTripDetail (data) {
  return Service({
    url: '/api/getTripDetail',
    method: 'post',
    params: data
  })
}
// 只获取 行程支付、创建时间
export function getTripTime (data) {
  return Service({
    url: '/api/getTripTime',
    method: 'post',
    params: data
  })
}
// 打印行程单
export function downloadTrip (data) {
  return Service({
    url: '/api/downloadTrip',
    method: 'post',
    params: data
  })
}

// 显示发票及凭证预览.
export function getShowPdf (data) {
  return Service({
    url: '/api/getTripDetail',
    method: 'post',
    params: data
  })
}

// 获取退款金额相关
export function getCancelPriceDetail (data) {
  return Service({
    url: '/api/getCancelPriceDetail',
    method: 'post',
    params: data
  })
}

// 取消订单
export function orderCancel (data) {
  return Service({
    url: '/api/orderCancel',
    method: 'post',
    params: data
  })
}
// 修改订单状态
export function modifyOrderStatus (data) {
  return Service({
    url: '/api/modifyOrderStatus',
    method: 'post',
    params: data
  })
}
// 下单数据verify
export function orderBookSearch (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 下单数据verify
export function orderBookVerify (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 订单填写信息页面展示数据
export function writeOrderShow (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 订单填写信息页面积分数据
export function getOrderPrice (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 订单填写信息页面展示数据
export function orderFillCosInfo (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 订单支付页面展示数据
export function writePayShow (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 支付页面完成预定
export function writePayFinishBook (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 支付页面完成预定
export function orderPayResultShow (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    data: data
  })
}

// 支付页面回调完成显示
export function orderPayCallbackResultShow (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 获取当前账户所有的订单单号
export function getAllOrderNos (data) {
  return Service({
    url: '/api/getAllOrderNos',
    method: 'post',
    params: data
  })
}

// 获取当前账户所有的订单单号
export function orderPayment (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 客人同意涨价，修改验证价格信息
export function updateVerifyPrice (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 支付子订单号
export function orderChildPayment (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 微信js支付获取签名
export function wechatJsPayGetSign (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

// 支付二次确认结果.
export function confirmResult (data) {
  return Service({
    url: '/api/orderBook',
    method: 'post',
    params: data
  })
}

export function exportData (data) {
  return Service({
    url: '/api/getTripList',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/order.js